import CircularProgress from "@mui/material/CircularProgress";
import { PORTAL_ACTION_BTN_OUTLINE_CLASS, PORTAL_ACTION_BTN_PRIMARY_CLASS } from "@constants/portalUiTheme";
import type { ProfileActionButtonsProps } from "../types";

const ProfileActionButtons: React.FC<ProfileActionButtonsProps> = ({
	isEditMode,
	isUpdating,
	onEdit,
	onCancel,
	t,
}) => {
	return (
		<div className="flex justify-end gap-4 border-t border-gray-100 px-6 pb-6 pt-4">
			{isEditMode ? (
				<>
					<button
						type="button"
						disabled={isUpdating}
						onClick={onCancel}
						className={PORTAL_ACTION_BTN_OUTLINE_CLASS}>
						{t("psdaCommon.common.buttons.cancel")}
					</button>
					<button
						type="submit"
						disabled={isUpdating}
						className={`${PORTAL_ACTION_BTN_PRIMARY_CLASS} inline-flex items-center justify-center gap-2`}>
						{isUpdating && <CircularProgress size={18} color="inherit" />}
						{t("psdaCommon.profile.buttons.save")}
					</button>
				</>
			) : (
				<button type="button" onClick={onEdit} className={PORTAL_ACTION_BTN_PRIMARY_CLASS}>
					{t("psdaCommon.profile.buttons.edit")}
				</button>
			)}
		</div>
	);
};

export default ProfileActionButtons;
